import { render, staticRenderFns } from "./m-sendModal.vue?vue&type=template&id=5da22872&scoped=true&"
import script from "./m-sendModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-sendModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-sendModal.vue?vue&type=style&index=0&id=5da22872&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da22872",
  null
  
)

export default component.exports